module.exports = __webpack_public_path__ + "static/media/LogoGPM.d87cd79f.png";